import React from "react";
//#region types
import { FormFieldProps } from "models/propTypes/genericFormProps";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { FieldArray, FieldArrayRenderProps } from "formik";
import { Grid } from "@mui/material";
import FormFieldWrapper from "../formFieldWrapper";
import RoundButton from "../../buttons/roundButton";
import Icon from "../../icon";
//#endregion

function MultipleInputFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, optional } = props;

  const onAddButtonClick = (arrayHelpers: FieldArrayRenderProps) => {
    if (value === undefined || value.length === 0) arrayHelpers.push(undefined);
    arrayHelpers.push(undefined);
  };

  const internalValue = value && value.length > 0 ? value : [undefined];

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <Grid item container spacing={1} alignItems="flex-end">
          <Grid item xs container spacing={1}>
            {internalValue.map((itemValue: any, itemIndex: number) =>
              Object.entries(field.innerFields ?? {}).map(([key, innerField], index) =>
                innerField ? (
                  <FormFieldWrapper
                    key={`${itemIndex}${index}`}
                    {...props}
                    field={innerField}
                    name={`${name}[${itemIndex}]${name !== key ? `.${key}` : ""}`}
                    overrideOptional={optional}
                  />
                ) : (
                  <></>
                )
              )
            )}
          </Grid>
          <Grid item style={{ height: 56 }}>
            <RoundButton size="sm" onClick={onAddButtonClick.bind(null, arrayHelpers)}>
              <Icon icon={IconDefinitionConstants.WPlus} />
            </RoundButton>
          </Grid>
        </Grid>
      )}
    />
  );
}

export default MultipleInputFormField;
